import type { Bootstrap, Task, TaskDetail } from './types';

export class ApiError extends Error {
  status: number; code?: string; currentTask?: Task;
  constructor(message: string, status: number, data: Record<string, unknown>) {
    super(message); this.status = status;
    this.code = typeof data.code === 'string' ? data.code : undefined;
    this.currentTask = data.currentTask as Task | undefined;
  }
}

async function request<T>(action: string, options: RequestInit = {}, params: Record<string, string | number> = {}): Promise<T> {
  const url = new URL('/api/index.php', window.location.origin);
  url.searchParams.set('action', action);
  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, String(value)));
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  const response = await fetch(url, { credentials: 'include', cache: 'no-store', ...options, headers });
  const data = await response.json().catch(() => ({ error: `HTTP ${response.status}` })) as Record<string, unknown>;
  if (!response.ok) throw new ApiError(String(data.error || `HTTP ${response.status}`), response.status, data);
  return data as T;
}

export const api = {
  bootstrap: (teacherMode = false) => request<Bootstrap>(teacherMode ? 'teacher_board_bootstrap' : 'task_board_bootstrap'),
  archive: () => request<{ tasks: Task[] }>('task_list_archive'),
  trash: () => request<{ tasks: Task[] }>('task_list_trash'),
  detail: (id: number) => request<TaskDetail & { success: true }>('task_get_detail', {}, { id }),
  json: <T>(action: string, body: Record<string, unknown>) => request<T>(action, { method: 'POST', body: JSON.stringify(body) }),
  upload: (taskId: number, file: File) => { const body = new FormData(); body.set('taskId', String(taskId)); body.set('file', file); return request<{ detail: TaskDetail }>('task_attachment_upload', { method: 'POST', body }); },
  poll: (since: number) => request<{ events: unknown[]; latestEventId: number }>('task_realtime_poll', {}, { since }),
};
